/* tslint:disable:no-trailing-whitespace */
import {
  AfterContentChecked, AfterContentInit, AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DataType} from '../../pusblisher/ipublisher';
import {DataGrid} from '../../DoraData/data-grid';
import {DataTupla} from '../../DoraData/data-tupla';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {DataRow} from '../../DoraData/data-row';
import {MessageSeriesSelected} from '../../messages/message-series-selected';
import {MessageRowsSelected} from '../../messages/message-rows-selected';
import {MessageColumnsSelected} from '../../messages/message-columns-selected';
import {DataTuplaDescription} from '../../DoraData/data-tupla-description';
import {TUPLA_TYPE} from '../../DoraData/data-base';
import {DoraProperty, DoraPropertyArray, DoraPropertyDOC} from '../../Decorators/Decorator';
import {MessageColumnsVisible} from '../../messages/message-columns-visible';
import {timer} from 'rxjs';
import {Column} from '../dora-row/data/column';
import {Id} from '../dora-row/data/id';
import {PublisherParameter} from '../widget-base/data/publisher-parameter';
import {Tupla} from '../dora-row/data/tupla';
import {FixedSeriesInfo} from '../../messages/data/fixed-series-info';
import {ReadResult} from '../../pusblisher/data/read-result';
import {MessageLastDate} from '../../messages/message-last-date';
import {formatDate} from '@angular/common';
import {PositionElement} from '../../Utility/position-element';
import {MessageRowsUnselected} from '../../messages/message-rows-unselected';
import {RowConfig} from './data/row-config';
import {MessageSeriesFixedEnabled} from '../../messages/message-series-fixed-enabled';
import {MessageDataFixedAvaiable} from '../../messages/message-data-fixed-avaiable';

@Component({
  selector: 'dora-data-grid',
  templateUrl: './dora-data-grid.component.html',
  styleUrls: ['./dora-data-grid.component.scss']
})
export class DoraDataGridComponent extends WidgetBaseComponent implements OnInit {
  // @ts-ignore
  @DoraPropertyDOC('Prova di documentazione')
  private mioAttributo = 5;
  @DoraProperty
  private idgrid = '';
  @DoraProperty
  protected checkBoxDisabled = false;
  @DoraProperty
  protected singleRowSelection = false;
  @DoraProperty
  protected toolTipEnabled = false;
  @DoraProperty
  private columnsSelectable = true;
  @DoraProperty
  private seriesReverseOrder = false;
  @DoraProperty
  private numberFormat = '#.#';
  @DoraProperty
  // the grid contains stocks
  private stockContent = false;

  // region: FixedSeries
  @DoraProperty
  // Field to use to build the fixed serie
  private fixedSeriesField = '';

  @DoraProperty
  // Generic field (true) or specific field (false).
  // If true the fixedSeriesField is the same for all rows, so it take the value from the first row
  private fixedSeriesGeneric = true;

  @DoraProperty
  // Optional color for fixed series
  private fixedSeriesColor = '';
  // endregion

  @DoraPropertyArray (Id)
  private idrows: Id[] = [];

  @DoraPropertyArray (RowConfig)
  // optional configuration for rows
  private rowsConfig: RowConfig[] = [];

  @DoraPropertyArray (Tupla)
  private tuplafilter: Tupla[] = [];

  // tupla to show
  private tuplafilterWrk: Tupla[] = [];

  @DoraPropertyArray (Id)
  // if present is the list of colors to use for the rows. If colors are less than rows, the colors are repeated
  private colors: Id[] = [];

  // if present is the tupla id to check to determine if the row is positive or negative
  @DoraProperty
  private idtuplaForStatus = '';

  // last date for price in rows. If not null use this date to che "rif. Precedente
  private lastDate: Date = null;
  protected dataGrid: DataGrid = null;
  private columnsSelected: string[] = [];
  private columnsVisible: string[] = [];

  // fixed series enabled. It depends on the fixedSeriesField. It is set with MessageSeriesFixedEnabled event
  private fixedSeriesEnabled = true;

  @ViewChild('innerWrapper') innerWrapper: ElementRef;
  @ViewChild('shadowLeft') shadowLeft: ElementRef;
  @ViewChild('shadowRight') shadowRight: ElementRef;
  @ViewChild('dagTable') dagTable: ElementRef;

  // opacity
  protected opacityLeft = 0.0;
  protected opacityRight = 0.0;

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();


    // todo test
    let res = Reflect.getMetadata('design:type', this, 'mioAttributo');

    console.log(res.name);

    this.setInitialFixing2PublisherParameters();



    this.readData();

    this.messageService.getMessage(this.EventChannel, MessageSeriesFixedEnabled, this.CallerName).subscribe(message => {
      this.fixedSeriesEnabled = (message.data as MessageSeriesFixedEnabled).isEnabled;
      this.sendEventsForSelectedRows(null);
    });

    this.messageService.getMessage(this.EventChannel, MessageColumnsVisible, this.CallerName).subscribe(message => {
      this.columnsVisible = (message.data as MessageColumnsVisible).idColumns;
      this.rebuildVisibleColumns();
    });
    this.messageService.getMessage(this.EventChannel, MessageGridSelected, this.CallerName).subscribe(message => {
      this.idgrid = (message.data as MessageGridSelected).idGrid;

      this.readData();
    });

    this.messageService.getMessage(this.EventChannel, MessageRowsUnselected, this.CallerName).subscribe(message => {

      const idRows: string[] = (message.data as MessageRowsUnselected).DataRows;
      this.dataGrid.unselectRows(idRows);
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageRowsSelected(this.dataGrid.getSelectedRows(), this.getFixedSeriesInfos(), this.publisherParameters), this.CallerName);
    });



    this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(message => {
      const idRows: string[] = [];

      (message.data as MessageRowsSelected).DataRows.forEach((dataRow: DataRow) => {
        idRows.push(dataRow.Id);
        });

      // select rows
      this.dataGrid.selectRows(idRows);

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      if (!this.stockContent) {
        // tslint:disable-next-line:max-line-length
        this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
      }
    });

    this.messageService.getMessage(this.EventChannel, MessageColumnsSelected, this.CallerName).subscribe( message => {
      this.columnsSelected = (message.data as MessageColumnsSelected).idColumns;

      this.dataGrid.selectTuplaDescription(this.columnsSelected);

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      if (!this.stockContent) {
        // tslint:disable-next-line:max-line-length
        this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
      }
    });

    this.messageService.getMessage(this.EventChannel, MessageLastDate, this.CallerName).subscribe(message => {
      this.lastDate = (message.data as MessageLastDate).LastDate;

      this.readData();
    });
  }

  /**
   * Set the initial fixing to publisher parameters analyzing the rowsConfig
   */
  private setInitialFixing2PublisherParameters(): void {
    // create new publisherParameter
    const initialFixingParameter = new PublisherParameter();
    initialFixingParameter.name = 'initialFixing';

    // loop for all rowsConfig
    this.rowsConfig.forEach((rowConfig: RowConfig) => {
      if (initialFixingParameter.value !== '') {
        initialFixingParameter.value += ',';
      }

      if (rowConfig.initialFixing !== 0.0) {
        initialFixingParameter.value += rowConfig.idRow + ':' + rowConfig.initialFixing;
      }
    });

    // add to publisherParameters
    if (initialFixingParameter.value !== '') {
      this.publisherParameters.push(initialFixingParameter);
    }
  }
  private readData(): void {
    if (this.idgrid === '' && this.idrows.length < 1) {
      // idgrid or idrows not set
      return;
    }
    if (this.idgrid !== '') {
      // Read table list
      this.read([this.idgrid], DataType.GRID).subscribe((data: any) => {
        this.dataGrid = (data as ReadResult).Data as DataGrid;
        this.onNewData();
      });
    } else if (this.idrows.length >= 1) {
      const rows2Subscribe: string[] = [];

      this.idrows.forEach( value => {
        // @ts-ignore
        rows2Subscribe.push((value.key));
      });

      // get additional parameters
      const publisherParameters  = this.getPublisherParameters(this.publisherParameters);

      // add last date if present
      if (this.lastDate !== null) {
        // format date to "yyyyMMdd"
      const lastDate = formatDate(this.lastDate, 'yyyyMMdd', 'en');
      publisherParameters.set('enddate', lastDate);
      }

      this.read(rows2Subscribe, DataType.ROWS, publisherParameters).subscribe((data: any) => {
        this.dataGrid = (data as ReadResult).Data as DataGrid;
        this.onNewData();
      });
    }
  }

  private onNewData(): void {
    this.setRowSelectable();
    this.filterDataGrid();
    this.setColorsToDataGrid();
    this.dataGrid.selectColumnsByType(TUPLA_TYPE.NUMBER);
    this.rebuildSelectedColumns();
    this.rebuildVisibleColumns();

    this.setWorstBestDataRows();
    this.sendFixedDataAvaiable();

    const myTime = timer(1000);
    myTime.subscribe(value => {
      this.onScroll();
    });


  }

  private setRowSelectable(): void {
    // loop for all rowsConfig
    this.rowsConfig.forEach((rowConfig: RowConfig) => {
      const dataRow = this.dataGrid.getDataRow(rowConfig.idRow);
      if (dataRow !== undefined) {
        dataRow.Selectable = rowConfig.hasHistorical ? true : false;
      }
    });
  }
  private setColorsToDataGrid(): void {
    if (this.colors.length === 0) {
      return;
    }

    // set colors to rows
    this.dataGrid.DataRows.forEach((dataRow: DataRow, index: number) => {
      const idColor = this.colors[index % this.colors.length].key;
      dataRow.Color = idColor;
    });
  }
  private filterDataGrid(): void {
    if (this.idtuplaForStatus !== '') {
      // Add column for status
      const tupla = new DataTupla();
      tupla.Id = 'STATUS';
      tupla.Type = TUPLA_TYPE.STRING;
      tupla.Value = '';

      const dataTuplaDescription = DataTuplaDescription.createFromTupla(tupla);

      this.dataGrid.tuplasDescription.push(dataTuplaDescription);
      // Add tupla for each row
      this.dataGrid.DataRows.forEach((dataRow: DataRow) => {
        const dataTupla = new DataTupla();
        dataTupla.Id = 'STATUS';
        dataTupla.Type = TUPLA_TYPE.STRING;
        dataTupla.Value = '';
        dataTupla.DataType = 'Tupla';
        dataTupla.Language = 'en';

        dataRow.DataTuplas.push(dataTupla);
      });
    }
    this.tuplafilterWrk = [];

    if (this.tuplafilter.length !== 0) {
      this.tuplafilterWrk = this.tuplafilter;

      const tuplaDescriptionFiltered: DataTuplaDescription[] = [];
      // loop for all tupla filter
      this.tuplafilter.forEach((tupla: Tupla) => {
        // check if tupla is present in dataTuplaDescription

        // tslint:disable-next-line:no-shadowed-variable
        const dataTuplaDescription = this.dataGrid.tuplasDescription.find((dataTuplaDescription: DataTuplaDescription) => {
          return dataTuplaDescription.Id === tupla.key;
        });

        if (dataTuplaDescription !== undefined) {
          tuplaDescriptionFiltered.push(dataTuplaDescription);
        }
      });

      this.dataGrid.tuplasDescription = tuplaDescriptionFiltered;

      // Filter tuplas for each rows
      this.dataGrid.DataRows.forEach((dataRow: DataRow) => {
        dataRow.DataTuplas = dataRow.DataTuplas.filter((dataTupla: DataTupla) => {
          return this.tuplafilter.find((id: Id) => {
            return id.key === dataTupla.Id ? true : false;
          }) === undefined ? false : true;
        });
      });
    } else {
      // no filter: return all tuplas
      this.dataGrid.tuplasDescription.forEach((dataTuplaDescription: DataTuplaDescription) => {
        this.tuplafilterWrk.push(dataTuplaDescription.createTupla());
      });
    }
  }

  /**
   * Return the css class for the row
   */
  public getRowCssClass(rowIndex: number, dataRow: DataRow): string {
    let result: string;

    result = dataRow.CssFormat;
    if (rowIndex % 2) {
      result += ' odd';
    } else {
      result += ' even';
    }

    // selecteble class
    if (dataRow.Selectable) {
      result += ' selectable';
    } else {
      result += ' unselectable';
    }

    // selected class
    if (dataRow.selected) {
      result += ' selected';
    }

    // chek if the row is positive or negative and wrost or best
    if (this.idtuplaForStatus !== '') {
      const tuplasForTest = dataRow.getDataTupla(this.idtuplaForStatus);

      if (tuplasForTest.Type === TUPLA_TYPE.NUMBER) {
        if (tuplasForTest.Value > 0) {
          result += ' pos';
        } else if (tuplasForTest.Value < 0) {
          result += ' neg';
        } else {
          result += ' equ';
        }
      }

    }
    return result;
  }

  public getHeaderCssClass(cellIndex: number, baseName: string, dataTuplaDescription: DataTuplaDescription): string {
    let result = baseName;

    result += ' ' + baseName + cellIndex.toString();

    if (!cellIndex) {
      result += ' ' + baseName + 'First';
    }

    if (cellIndex === this.dataGrid.tuplasDescription.length - 1) {
      result += ' ' + baseName + 'Last';
    }

    // only NUMBER columns are selectable
    if (dataTuplaDescription.Type === TUPLA_TYPE.NUMBER && this.columnsSelectable === true) {
      // class for select
      result += ' ' + baseName + ((dataTuplaDescription.selected === true) ? 'selected' : 'unselected');
    }

    // class with colum id
    result += ' id-' + dataTuplaDescription.Id.replace(' ', '-');
    return result;
  }

  public getColSpan(dataRow: DataRow, cellIndex: number, dataTupla: DataTupla = null): number {
    if (dataTupla === null) {
      return 0;
    }

    const colSpan = dataRow.getColSpan(cellIndex);
    return colSpan;
  }
  public getCellCssClass(cellIndex: number, baseName: string, dataTupla: DataTupla = null): string {
    let result = baseName;
    let idx = this.dataGrid.tuplasDescription.findIndex(tuplaDescription =>
      tuplaDescription.Id === dataTupla.Id );

    if (idx === undefined) {
      idx = cellIndex;
    }
    result += ' ' + baseName + idx.toString();

    if (idx === 0) {
      result += ' ' + baseName + 'First';
    }

    if (idx === this.dataGrid.tuplasDescription.length - 1) {
      result += ' ' + baseName + 'Last';
    }

    if (dataTupla != null) {
      result += ' type-' + TUPLA_TYPE[dataTupla.Type];

      // empty/no-empty
      if (dataTupla.Value === '') {
        result += ' empty';
      } else {
        result += ' no-empty';
      }

      if (dataTupla.Type === TUPLA_TYPE.NUMBER) {
        if (dataTupla.Value > 0) {
          result += ' pos';
        } else if (dataTupla.Value < 0) {
          result += ' neg';
        } else {
          result += ' equ';
        }
      }
    }
    // class with colum id
    result += ' id-' + dataTupla.Id.replace(' ', '-');

    return result;
  }

  public getCellUnitSx(dataTupla: DataTupla, row: DataRow): string {
    const tupla = this.tuplafilterWrk.find((tuplaElement: Tupla) => {
      return tuplaElement.key === dataTupla.Id;
    });

    return tupla === undefined ? '' : this.decodeUnit(tupla.unitSx, row);
  }

  public getCellUnitDx(dataTupla: DataTupla, row: DataRow): string {
    const tupla = this.tuplafilterWrk.find((tuplaElement: Tupla) => {
      return tuplaElement.key === dataTupla.Id;
    });
    return tupla === undefined ? '' : this.decodeUnit(tupla.unitDx, row);
  }

  public getCellValue(dataTupla: DataTupla): string {
    // get tupla filter
    const dataTuplaDescription = this.getTuplaFiltered(dataTupla.Id);

    let format = '';

    if (dataTupla.OutputFormat !== undefined && dataTupla.OutputFormat !== '') {
      format = dataTupla.OutputFormat;
    } else {
      // tslint:disable-next-line:max-line-length
      format = dataTuplaDescription.format === undefined || dataTuplaDescription.format === '' ? this.numberFormat : dataTuplaDescription.format;
    }
    return dataTupla.getTrimmedValue('-',  format, this.translationService);
  }

  /**
   * Return the tupla description for the id
   */
  private getTuplaFiltered(id: string): Tupla {
    return this.tuplafilterWrk.find((tupla: Tupla) => {
      return tupla.key === id;
    });
  }

  private decodeUnit(unit: string, row: DataRow): string {
    // substitute all [UNIT] with the unit of the row
    return unit.replace('[UNIT]', row.Units);
  }
  public getColumnName(dataTuplaDescription: DataTuplaDescription): string {
    return this.translationService.get(dataTuplaDescription.Name);
  }
  public getToolTip(dataTuplaDescription: DataTuplaDescription): string {
    if (this.toolTipEnabled === true) {
      return this.translationService.getWithDefault(dataTuplaDescription.Name + '_TOOLTIP', '');
    }
    return '';
  }

  /**
   * Return true if the tooltip is enabled
   */
  public isToolTipEnabled(dataTuplaDescription: DataTuplaDescription): boolean {
    if (this.toolTipEnabled === true) {
      if (this.getToolTip(dataTuplaDescription) !== '') {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  public getToolTipVisibility(dataTuplaDescription: DataTuplaDescription): string {
    return dataTuplaDescription.tooltipVisible === true ? 'visible' : 'hidden';
  }

  public onHeaderTooltipMouseEnter(dataTuplaDescription: DataTuplaDescription): void {
    dataTuplaDescription.tooltipVisible = true;
  }
  public onHeaderTooltipMouseLeave(dataTuplaDescription: DataTuplaDescription): void {
    dataTuplaDescription.tooltipVisible = false;
  }
  private rebuildSelectedColumns(): void {
    this.columnsSelected = [];
    this.dataGrid.tuplasDescription.forEach((x: DataTuplaDescription) => {
      if (x.selected) {
        this.columnsSelected.push(x.Id);
      }
    });
  }

  private setWorstBestDataRows(): void {
    if (this.idtuplaForStatus === '') {
      return;
    }
    if (this.dataGrid.DataRows.length === 1) {
      // only one row: set as best
      this.dataGrid.DataRows[0].addCssClass('best');
      return;
    }

    // get DataRow with max value
    const dataRowMax: DataRow = this.dataGrid.DataRows.reduce((prev, current) => {
      const tuplaPrev = prev.getDataTupla(this.idtuplaForStatus);
      const tuplaCurrent = current.getDataTupla(this.idtuplaForStatus);

      // check if tupla is present
      if (tuplaPrev === undefined || tuplaCurrent === undefined) {
        return prev;
      }

      if (tuplaPrev.Value > tuplaCurrent.Value) {
        return prev;
      } else {
        return current;
      }
    });
    let tuplaStatus = dataRowMax.getDataTupla('STATUS');
    if (tuplaStatus !== undefined) {
      tuplaStatus.Value = 'BEST';
    }
    dataRowMax.addCssClass('best');


    // get DataRow with min value
    const dataRowMin: DataRow = this.dataGrid.DataRows.reduce((prev, current) => {
      const tuplaPrev = prev.getDataTupla(this.idtuplaForStatus);
      const tuplaCurrent = current.getDataTupla(this.idtuplaForStatus);

      if (tuplaPrev.Value < tuplaCurrent.Value) {
        return prev;
      } else {
        return current;
      }
    });
    tuplaStatus = dataRowMin.getDataTupla('STATUS');
    if (tuplaStatus !== undefined) {
      tuplaStatus.Value = 'WORST';
    }
    dataRowMin.addCssClass('worst');
  }
  private rebuildVisibleColumns(): void {
    if (this.columnsVisible.length === 0 || this.dataGrid === null) {
      return;
    }
    this.dataGrid.setColumnsVisible(this.columnsVisible);
  }
  // User Events
  public onRowClick(dataRow: DataRow, mouseEvent: MouseEvent): void {

    dataRow.swapSelected();
    if (this.singleRowSelection === true && dataRow.selected === true) {
      // disable all other rows
      this.dataGrid.selectRowMutex(dataRow.Id);
    }

    this.sendEventsForSelectedRows(mouseEvent);
    this.sendFixedDataAvaiable();
  }

  private sendEventsForSelectedRows(mouseEvent?: MouseEvent): void {
    if (this.dataGrid === null) {
      return;
    }

    // tslint:disable-next-line:max-line-length
    if (!this.stockContent && mouseEvent !== null) {
      const targetPosition = new PositionElement(mouseEvent.target);
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected), targetPosition), this.CallerName);
    }

    // fire event of selected row
    // tslint:disable-next-line:max-line-length
    this.messageService.sendMessage(this.EventChannel, new MessageRowsSelected(this.dataGrid.getSelectedRows(), this.getFixedSeriesInfos(), this.publisherParameters), this.CallerName);

  }
  /**
   * Return the fixed series info
   */
  private getFixedSeriesInfos(): FixedSeriesInfo[] {
    const fixedSeriesInfos: FixedSeriesInfo[] = [];

    if (this.fixedSeriesField !== '' && this.fixedSeriesEnabled) {
      if (this.fixedSeriesGeneric === true) {
        // generic field
        const selectedRows = this.dataGrid.getSelectedRows();
        if (selectedRows.length > 0) {
          const dataTupla = selectedRows[0].getDataTupla(this.fixedSeriesField);
          if (dataTupla !== undefined) {
            const fixedSeriesInfo = new FixedSeriesInfo();
            fixedSeriesInfo.name = this.getColumnName(this.dataGrid.getTuplaDescription(this.fixedSeriesField));
            fixedSeriesInfo.value = dataTupla.Value;
            fixedSeriesInfo.type = dataTupla.Type;
            fixedSeriesInfo.color = this.fixedSeriesColor;
            fixedSeriesInfos.push(fixedSeriesInfo);
          }
        }
      } else {
        // specific field
        this.dataGrid.getSelectedRows().forEach((dataRow: DataRow) => {
          const dataTupla = dataRow.getDataTupla(this.fixedSeriesField);
          if (dataTupla !== undefined) {
            const fixedSeriesInfo = new FixedSeriesInfo();
            // todo: deve aggiungere la descrizione della riga. Il field description il cui id deve essere nei parametri del widget
            fixedSeriesInfo.name = this.getColumnName(this.dataGrid.getTuplaDescription(this.fixedSeriesField));
            fixedSeriesInfo.value = dataTupla.Value;
            fixedSeriesInfo.type = dataTupla.Type;
            fixedSeriesInfo.color = this.fixedSeriesColor;
            fixedSeriesInfos.push(fixedSeriesInfo);
          }
        });
      }
    }

    return fixedSeriesInfos;
  }

  /**
   * Send message MessageDataFixedAvaiable
   */
  public sendFixedDataAvaiable(): void {
    let dataFixedAvaiable = false;

    if (this.fixedSeriesField !== '' && this.dataGrid != null) {
      const selectedRows = this.dataGrid.getSelectedRows();
      if (selectedRows.length > 0) {
        const dataTupla = selectedRows[0].getDataTupla(this.fixedSeriesField);
        if (dataTupla !== undefined) {
          dataFixedAvaiable = true;
        }
      }
    }

    this.messageService.sendMessage(this.EventChannel, new MessageDataFixedAvaiable(dataFixedAvaiable), this.CallerName);
  }
  public onHeaderClick(tuplaDescription: DataTuplaDescription): void {
    if (tuplaDescription.Type === TUPLA_TYPE.NUMBER && this.columnsSelectable === true) {
      tuplaDescription.switchSelected();

      this.rebuildSelectedColumns();

      // build series and fire event
      if (!this.stockContent) {
        // tslint:disable-next-line:max-line-length
        this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
      }
    }
  }

  public onScroll(): void {
    if (this.innerWrapper === undefined) {
      return;
    }
    const tableScrollLeft = this.innerWrapper.nativeElement.scrollLeft;
    const tableScrollRight = this.dagTable.nativeElement.offsetWidth -
      this.innerWrapper.nativeElement.offsetWidth -
      this.innerWrapper.nativeElement.scrollLeft;

    this.opacityLeft = this.getScrollOpacity(this.shadowLeft.nativeElement, tableScrollLeft);
    this.opacityRight = this.getScrollOpacity(this.shadowRight.nativeElement, tableScrollRight);
  }
  private getScrollOpacity(shadowElement, scrollPosition): number {
    const shadowElemWidth = shadowElement.offsetWidth;

    if ((scrollPosition / shadowElemWidth) <= 0 ) {
      return 0.0;
    } else if ( scrollPosition <= shadowElemWidth ) {
      return scrollPosition / shadowElemWidth;
    }

    return 1.0;
  }

  protected readonly PositionElement = PositionElement;
}
